"use client";
import React from "react";
import img1 from "../../../../assets/img/37.png";
import img2 from "../../../../assets/img/38.png";
import logo1 from "../../../../assets/img/logoPro.png";
import authDark from "../../../../assets/img/auth-dark.png";

import { useForm } from "react-hook-form";

import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import useApiRequest from "../../../../Hooks/apiReq";
import Loader from "../../../../CommonComponets/Loader";
import InputBox from "../../Pages/CustomerArea/PromoteAsAssociate/InputBox";

const ChangePassword = () => {
  const navigate = useNavigate();

  const { loading, sendApiRequest } = useApiRequest();

  // useForm setup
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
    mode: "onTouched",
  });

  const newPassword = watch("newPassword");
  const confirmPassword = watch("confirmPassword");
  const oldPassword = watch("oldPassword");
  // console.log(newPassword, confirmPassword, oldPassword);
  const onSubmit = async (data) => {
    sendApiRequest(
      "POST",
      "/Profile/ChangePassword",
      {
        strNewPassword: data.newPassword,
        strOldPassword: data?.oldPassword,
      },
      {
        onSuccess: (res) => {
          toast.success(res?.message);
          reset({
            newPassword: "",
            confirmPassword: "",
            oldPassword: "",
          });
        },
      },
    );
  };

  return (
    <>
      <main className="main" id="top">
        <div className="container-fluid bg-body-tertiary dark__bg-gray-1200">
          <div
            className="bg-holder bg-auth-card-overlay"
            style={{ backgroundImage: `url(${img1})` }}
          ></div>

          <div className="row flex-center position-relative min-vh-100 g-0 py-5">
            <div className="col-11 col-sm-10 col-xl-8">
              <div className="card border border-translucent auth-card">
                <div className="card-body pe-md-0">
                  <div className="row align-items-center gx-0 gy-7">
                    {/* Left Side */}
                    <div className="col-auto bg-body-highlight dark__bg-gray-1100 rounded-3 position-relative overflow-hidden auth-title-box">
                      <div
                        className="bg-holder"
                        style={{ backgroundImage: `url(${img2})` }}
                      ></div>
                      <div className="position-relative px-4 px-lg-7 pt-7 pb-7 pb-sm-5 text-center text-md-start">
                        <h3 className="mb-3 text-body-tertiary fs-7">
                          Keep your account secure by choosing a strong, unique
                          password.
                        </h3>
                        <ul className="list-unstyled mb-0 w-max-content w-md-auto">
                          {["Fast", "Simple", "Secure"].map((item) => (
                            <li
                              className="d-flex align-items-center"
                              key={item}
                            >
                              <span className="uil uil-check-circle text-success me-2"></span>
                              <span className="text-body-tertiary fw-semibold">
                                {item}
                              </span>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="position-relative z-n1 mb-6 d-none d-md-block text-center mt-md-15">
                        <img
                          className="auth-title-box-img"
                          src={authDark}
                          alt="auth illustration"
                        />
                      </div>
                    </div>

                    {/* Right Side */}
                    <div className="mx-auto col">
                      <div className="text-center">
                        <Link
                          to="/"
                          className="d-inline-block text-decoration-none mb-4"
                        >
                          <div className="fw-bolder fs-5 d-inline-flex align-items-center">
                            <img alt="phoenix" width="158" src={logo1} />
                          </div>
                        </Link>
                      </div>

                      <div className="auth-form-box">
                        <div className="px-xxl-5">
                          <div className="text-center mb-5">
                            <h4 className="mb-3">Enter your new password</h4>
                          </div>
                          {/* Form */}
                          <form onSubmit={handleSubmit(onSubmit)} noValidate>
                            <div className="col-12 mb-3">
                              <InputBox
                                id="oldPassword"
                                type="password"
                                label="Existing password"
                                placeholder="Existing password"
                                required
                                {...register("oldPassword", {
                                  required: "Existing password is required",
                                })}
                                error={errors.oldPassword?.message}
                                // value={oldPassword}
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <InputBox
                                id="newPassword"
                                type="password"
                                label="New password"
                                placeholder="New password"
                                required
                                {...register("newPassword", {
                                  required: "New password is required",
                                  minLength: {
                                    value: 3,
                                    message: "Minimum 4 characters required",
                                  },
                                })}
                                error={errors.newPassword?.message}
                                isErrorClass={true}
                                // value={newPassword}
                              />
                            </div>
                            <div className="col-12 mb-3">
                              <InputBox
                                id="confirmPassword"
                                type="password"
                                label="Confirm new password"
                                placeholder="Confirm new password"
                                required
                                {...register("confirmPassword", {
                                  required: "Please confirm your password",
                                  validate: (val) =>
                                    val === newPassword ||
                                    "Passwords do not match",
                                })}
                                error={errors.confirmPassword?.message}
                                isErrorClass={true}
                                // value={confirmPassword}
                              />
                            </div>
                            <div className="row mb-5">
                              <div className="col-12">
                                <button
                                  type="submit"
                                  disabled={isSubmitting}
                                  className="w-100 btn btn-dark"
                                >
                                  {isSubmitting ? "Updating..." : "Update"}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                    {/* End Right */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {loading && <Loader />}
      </main>
    </>
  );
};

export default ChangePassword;
